import React, { useEffect, useState } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import { format, parseISO } from "date-fns";
import { useFormik } from "formik";
import { serviceInfoValidationSchema } from "./validations";
import LoadingSpinner from "../../Components/spinner";
import { useNavigate, useParams, useLocation } from "react-router-dom";
const ServiceInformation = ({
  formikRef,
  handlePreviousTab,
  empData,
  submitEntireForm,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const fromProfile = location.state?.fromProfile;
  const [loading, setLoading] = useState(false);
  const formik = useFormik({
    initialValues: {
      hiring_date: empData?.hiring_date || "",
      confirmation_date: empData?.confirmation_date || "",
      joining_date: empData?.joining_date || "",
      regular_date: empData?.regular_date || "",
      left_date: empData?.left_date || "",
      probation_end_date: empData?.probation_end_date || "",
    },
    validationSchema: serviceInfoValidationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        await submitEntireForm(values);
      } catch (error) {
        console.log("Error Upon form submition", error);
      } finally {
        setLoading(false);
      }
    },
  });
  const onPressPrevious = async () => {
    const errors = await formik.validateForm();
    if (Object.keys(errors).length > 0) {
      formik.setTouched(errors);
      return;
    }
    handlePreviousTab();
  };
  useEffect(() => {
    formikRef.current.serviceInfo = formik;
  }, [formik]);
  return (
    <Form>
      <Form.Group className="mb-3">
        <Row className="g-3">
          {/* Hiring Date */}
          <Col md={4}>
            <Form.Label>Hiring Date</Form.Label>
            <Form.Control
              type="date"
              data-testid="hiringDate"
              className="bg-dark text-light border-light input-placeholder-light"
              placeholder="Select Date"
              {...formik.getFieldProps("hiring_date")}
              value={
                formik.values.hiring_date
                  ? format(parseISO(formik.values.hiring_date), "yyyy-MM-dd")
                  : ""
              }
              isInvalid={
                formik.touched.hiring_date && !!formik.errors.hiring_date
              }
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.hiring_date}
            </Form.Control.Feedback>
          </Col>
          {/* Confirmation Date */}
          <Col md={4}>
            <Form.Label>Confirmation Date</Form.Label>
            <Form.Control
              type="date"
              data-testid="ConfirmationDate"
              className="bg-dark text-light border-light input-placeholder-light"
              placeholder="Select Date"
              {...formik.getFieldProps("confirmation_date")}
              value={
                formik.values.confirmation_date
                  ? format(
                      parseISO(formik.values.confirmation_date),
                      "yyyy-MM-dd"
                    )
                  : ""
              }
              isInvalid={
                formik.touched.confirmation_date &&
                !!formik.errors.confirmation_date
              }
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.confirmation_date}
            </Form.Control.Feedback>
          </Col>
          {/* Join Date */}
          <Col md={4}>
            <Form.Label>Joining Date</Form.Label>
            <Form.Control
              type="date"
              data-testid="joiningDate"
              className="bg-dark text-light border-light input-placeholder-light"
              placeholder="Select Date"
              {...formik.getFieldProps("joining_date")}
              value={
                formik.values.joining_date
                  ? format(parseISO(formik.values.joining_date), "yyyy-MM-dd")
                  : ""
              }
              isInvalid={
                formik.touched.joining_date && !!formik.errors.joining_date
              }
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.joining_date}
            </Form.Control.Feedback>
          </Col>
        </Row>

        <Row className="g-3 mt-3">
          <Col md={4}>
            <Form.Label>Regular Date</Form.Label>
            <Form.Control
              type="date"
              data-testid="regularDate"
              className="bg-dark text-light border-light input-placeholder-light"
              name="regular_date"
              {...formik.getFieldProps("regular_date")}
              value={
                formik.values.regular_date
                  ? format(parseISO(formik.values.regular_date), "yyyy-MM-dd")
                  : ""
              }
              isInvalid={
                formik.touched.regular_date && !!formik.errors.regular_date
              }
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.regular_date}
            </Form.Control.Feedback>
          </Col>

          <Col md={4}>
            <Form.Label>Left Date</Form.Label>
            <Form.Control
              type="date"
              data-testid="leftDate"
              className="bg-dark text-light border-light input-placeholder-light"
              name="left_date"
              {...formik.getFieldProps("left_date")}
              value={
                formik.values.left_date
                  ? format(parseISO(formik.values.left_date), "yyyy-MM-dd")
                  : ""
              }
              isInvalid={formik.touched.left_date && !!formik.errors.left_date}
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.left_date}
            </Form.Control.Feedback>
          </Col>

          <Col md={4}>
            <Form.Label>Probation End Date</Form.Label>
            <Form.Control
              type="date"
              data-testid="probationEndDate"
              className="bg-dark text-light border-light input-placeholder-light"
              name="probation_end_date"
              {...formik.getFieldProps("probation_end_date")}
              value={
                formik.values.probation_end_date
                  ? format(
                      parseISO(formik.values.probation_end_date),
                      "yyyy-MM-dd"
                    )
                  : ""
              }
              isInvalid={
                formik.touched.probation_end_date &&
                !!formik.errors.probation_end_date
              }
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.probation_end_date}
            </Form.Control.Feedback>
          </Col>
        </Row>
        <div className="container-fluid mt-4 ">
          <div className="d-flex justify-content-end">
            {loading && <LoadingSpinner size="lg" />}
            <Button
              variant="success"
              onClick={onPressPrevious}
              className="mb-4 mr-2"
            >
              ← Previous
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                if (fromProfile && id) {
                  navigate(`/EmployeeProfile/${id}`);
                } else {
                  navigate("/employees");
                }
              }}
              className="mb-4 ml-2"
            >
              Exit
            </Button>
            <Button
              variant="success"
              onClick={() => {
                formik.handleSubmit();
              }}
              className="mb-4 ml-2"
            >
              Save Service Info
            </Button>
          </div>
        </div>
      </Form.Group>
    </Form>
  );
};
export default ServiceInformation;
